import "./rightbar.css";
import { useState, useEffect, useContext } from "react";
import SocialContext from "../../context/SocialContext";
import axios from "axios";
import { Link } from "react-router-dom";

const host = "http://localhost:5000/api/";

export default function Rightbar({ user }) {
  const { user: currentuser } = useContext(SocialContext);
  // const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PF = "https://socialshub.netlify.app/images/";
  return (
    <>
      <div className="rightbar">
        <div className="rightbarWrapper">
          <div className="rightprofile">
            <h4 className="rightbarTitle">{currentuser.username}</h4>
            <img className="homeProfileImg" src={currentuser.profilePic ? currentuser.profilePic : PF + "/person/noprofile.jpeg"} alt="" />
          </div>
          <hr />
          <div className="rightProfilebottom">
            <Link style={{'textDecoration':'none'}} to={`/profile/${currentuser._id}`}><button className="rightBtn">View Profile</button></Link>
          </div>
        </div>
        <Link style={{'textDecoration':'none'}} to={'/share'}><button className="rightShareBtn">Create Post</button></Link>
      </div>
    </>
  )
}